import { c as _c } from "react/compiler-runtime";
import { useAppNavigation } from "@hooks/navigation/use-app-navigation";
import { Box } from "@mui-wrapper";
import { AccountSettingsMobileHeader } from "@pages/account-settings/account-settings-layout/mobile-layout/account-settings-mobile-header";
import { useAccountSettingsMobileMenu } from "@pages/account-settings/account-settings-layout/mobile-layout/use-account-settings-mobile-menu";
import { useAppSelector } from "@store/store-helper";
import { loggedInUserSelector } from "@store/user/user-selector";
import { Text } from "@flat-ui";
import { useCloseAccountSettings } from "@pages/account-settings/use-close-account-settings";
import { OpenTabEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
/** The mobile layout for account settings tab contents */
export function AccountSettingsMobileTabContents(t0) {
  const $ = _c(31);
  const {
    tabs,
    selectedTabId
  } = t0;
  const {
    trackEvent
  } = useTrackEvent();
  const loggedInUser = useAppSelector(loggedInUserSelector);
  const {
    navigateToRoot
  } = useAppNavigation();
  const {
    onCloseButtonClick
  } = useCloseAccountSettings();
  const {
    openTabSelection
  } = useAccountSettingsMobileMenu();
  const selectedTab = tabs[selectedTabId];
  let T0;
  let t1;
  let t2;
  let t3;
  if ($[0] !== loggedInUser || $[1] !== navigateToRoot || $[2] !== onCloseButtonClick || $[3] !== openTabSelection || $[4] !== selectedTab.content || $[5] !== selectedTab.label || $[6] !== trackEvent) {
    const filteredTabContents = selectedTab.content.filter(_temp);
    let t4;
    if ($[11] !== loggedInUser || $[12] !== navigateToRoot || $[13] !== openTabSelection || $[14] !== trackEvent) {
      t4 = function onOpenTabSelection() {
        trackEvent({
          name: OpenTabEvents.openAccountSettingsTab,
          props: {
            tab: "Tab selection list",
            isUserLoggedIn: !!loggedInUser
          }
        });
        if (loggedInUser) {
          openTabSelection();
        } else {
          navigateToRoot();
        }
      };
      $[11] = loggedInUser;
      $[12] = navigateToRoot;
      $[13] = openTabSelection;
      $[14] = trackEvent;
      $[15] = t4;
    } else {
      t4 = $[15];
    }
    const onOpenTabSelection = t4;
    let t5;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = {
        color: "text.primary",
        fontSize: "1.5rem"
      };
      $[16] = t5;
    } else {
      t5 = $[16];
    }
    let t6;
    if ($[17] !== selectedTab.label) {
      t6 = <Text variant="bodyL" sx={t5}>{selectedTab.label}</Text>;
      $[17] = selectedTab.label;
      $[18] = t6;
    } else {
      t6 = $[18];
    }
    if ($[19] !== onCloseButtonClick || $[20] !== onOpenTabSelection || $[21] !== t6) {
      t3 = <AccountSettingsMobileHeader menuLabel="Open Account Settings menu" onMenuClick={onOpenTabSelection} onCloseClick={onCloseButtonClick}>{t6}</AccountSettingsMobileHeader>;
      $[19] = onCloseButtonClick;
      $[20] = onOpenTabSelection;
      $[21] = t6;
      $[22] = t3;
    } else {
      t3 = $[22];
    }
    T0 = Box;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = {
        mt: "20px",
        mx: "15px"
      };
      $[23] = t1;
    } else {
      t1 = $[23];
    }
    t2 = filteredTabContents.map(_temp3);
    $[0] = loggedInUser;
    $[1] = navigateToRoot;
    $[2] = onCloseButtonClick;
    $[3] = openTabSelection;
    $[4] = selectedTab.content;
    $[5] = selectedTab.label;
    $[6] = trackEvent;
    $[7] = T0;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    T0 = $[7];
    t1 = $[8];
    t2 = $[9];
    t3 = $[10];
  }
  let t4;
  if ($[24] !== T0 || $[25] !== t1 || $[26] !== t2) {
    t4 = <T0 sx={t1}>{t2}</T0>;
    $[24] = T0;
    $[25] = t1;
    $[26] = t2;
    $[27] = t4;
  } else {
    t4 = $[27];
  }
  let t5;
  if ($[28] !== t3 || $[29] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[28] = t3;
    $[29] = t4;
    $[30] = t5;
  } else {
    t5 = $[30];
  }
  return t5;
}
function _temp3(section, index) {
  return <Box key={index} sx={{
    mt: index === 0 ? "20px" : "80px"
  }}><Text variant="heading16" component="div" sx={{
      color: "text.primary",
      mb: "8px"
    }}>{section.title}</Text><Text variant="bodyS" component="div" sx={{
      lineHeight: "18px",
      color: "text.primary",
      mb: "24px"
    }}>{section.subtitle}</Text>{section.items.map(_temp2)}</Box>;
}
function _temp2(item, index_0) {
  return <Box key={index_0}>{item.content}</Box>;
}
function _temp(selectedTabContent) {
  return !selectedTabContent.isHidden;
}